import { useCallback } from 'react';
import useConfirmationDialog, {
  DialogButtonColors,
  DialogButtonVariants,
} from 'src/components/ConfirmationDialog/view';
import { useContactsApi } from 'src/modules/contacts/api';
import { MarkContactAsValidDialogParams } from '../types';

export const useMarkContactAsValidDialogController = () => {
  const { updateContactInfo } = useContactsApi();
  const { openDialog, ConfirmationDialog } = useConfirmationDialog();

  const handleMarkContactAsValid = useCallback(
    ({ selectedCompanyId, contact, nextAction }: MarkContactAsValidDialogParams) => {
      const dialogConfig = {
        title: `Mark contact as valid`,
        content: `By marking this contact as valid you will be able to attempt to send this contact messages.`,
        confirmButtonText: 'Mark as Valid',
        confirmButtonColor: 'primary' as DialogButtonColors,
        cancelButtonColor: 'error' as DialogButtonColors,
        cancelButtonVariant: 'outlined' as DialogButtonVariants,
      };

      openDialog({
        ...dialogConfig,
        onConfirm: () => {
          const validContact = {
            phoneNumber: contact.phoneNumber,
            email: contact.email,
            firstName: contact.firstName,
            lastName: contact.lastName,
            birthdate: contact.birthdate,
            timeZone: contact.timeZone,
            assignedTo: contact.assignedTo,
            validStatus: 'valid',
          };
          updateContactInfo(selectedCompanyId!, contact.id, validContact).then(() => {
            nextAction?.();
          });
        },
      });
    },
    [openDialog, updateContactInfo],
  );

  return {
    handleMarkContactAsValid,
    MarkContactAsValidDialog: ConfirmationDialog,
  };
};
